import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/index/index')
    },
    {
      path: '/resources',
      name: 'Resources',
      component: () => import('@/views/resources/resources'),
      meta: {
        title: '资源中心'
      }
    },
    {
      path: '/resources/info/:id',
      name: 'ResourcesInfo',
      component: () => import('@/views/resources/resources-info'),
      meta: {
        title: '资源中心'
      },
      props: true
    },
    {
      path: '/goods',
      name: 'Goods',
      component: () => import('@/views/goods/goods'),
      meta: {
        title: '商品中心'
      }
    },
    {
      path: '/goods/info/:id',
      name: 'GoodsInfo',
      component: () => import('@/views/goods/goods-info'),
      meta: {
        title: '商品中心'
      },
      props: true
    },
    {
      path: '/notice',
      name: 'Notice',
      component: () => import('@/views/notice/notice'),
      meta: {
        title: '公告'
      }
    },
    {
      path: '/notice/info/:id',
      name: 'NoticeInfo',
      component: () => import('@/views/notice/notice-info'),
      meta: {
        title: '公告'
      },
      props: true
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/register/register'),
      meta: {
        title: '注册'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/login'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/member',
      name: 'Member',
      component: () => import('@/views/member/member'),
      meta: {
        title: '个人中心'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js